
import {finalize} from 'rxjs/operators';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { DateService } from '../../services/date/date.service';
import { Severity } from '../../services/flash-messages/flash-message.model';
import { FlashMessagesService } from '../../services/flash-messages/flash-messages.service';
import { Site } from '../../services/sites/site.model';
import { Truck } from '../../services/trucks/truck.model';
import { TrucksService } from '../../services/trucks/trucks.service';
import { ReturnUrlService } from '../../services/return-url/return-url.service';
import * as moment from 'moment';

@Component({
    selector: 'app-unit-search',
    templateUrl: './unit-search.component.html',
    styleUrls: ['./unit-search.component.css']
})
export class UnitSearchComponent {
    messageIds = {
        httpError: <string>null,
        noResults: <string>null
    };

    searching = false;
    site = <Site>null;
    truckDesignation = <string>null;
    trucks = <Truck[]>[];

    constructor(private dateService: DateService,
                private flashMessagesService: FlashMessagesService,
                private router: Router,
                private returnUrlService: ReturnUrlService,
                private trucksService: TrucksService) {
        this.returnUrlService.save();
    }

    clear(): void {
        this.truckDesignation = null;
        this.trucks = <Truck[]>[];
        this.flashMessagesService.clear(this.messageIds.httpError);
        this.flashMessagesService.clear(this.messageIds.noResults);
    }

    createRequest(): void {
        const truck = this.trucks.find((value: Truck) => value.truckDesignation === this.truckDesignation);
        const timestamp = moment.parseZone(truck.timestamp);

        // noinspection JSIgnoredPromiseFromCall
        this.router.navigate(['create-video-request', truck.truckNumber], {
            queryParams: {
                computerType: truck.computerType,
                deviceId: truck.deviceId,
                ipAddress: truck.ipAddress,
                site: this.site.siteNumber,
                softwareVersion: truck.softwareVersion,
                timestamp: this.dateService.momentToClosestMinute(timestamp).format(),
                business: truck.business,
                searchType: 'unit-search'
            }
        });
    }

    getPlaceholderText(): string {
        return `Select From ${this.trucks.length} Units`;
    }

    isValid(): boolean {
        return !!(this.site && this.truckDesignation)
            && this.trucks.some((truck: Truck): boolean => truck.truckDesignation === this.truckDesignation);
    }

    selectSite(site: Site): void {
        this.searching = true;
        this.site = site;
        this.clear();

        // noinspection JSIgnoredPromiseFromCall
        this.trucksService
            .get(site.siteNumber).pipe(
            finalize(() => {
            this.searching = false;
        })).subscribe(trucks => {
            if (trucks.length === 0) {
                this.messageIds.noResults = this.flashMessagesService.addMessage(Severity.Warning, 'No units found.');
            } else {
                this.trucks = trucks;
            }
        }, error => {
            this.messageIds.httpError = this.flashMessagesService.addMessageFor(error);
        });
    }
}
